import "core-js/modules/es.regexp.flags";

/* eslint-disable import/prefer-default-export */
export var flagSelector = function flagSelector(state) {
  return state.page.flags;
};